import React from 'react';
import { SectionContainer } from '@/components';
import { formatMessage } from '@/locales';
import './home-banner.view.less';

import GameCard from './components/game-shortcut/game-shortcut.component';

import { GAME_ICON_LIST } from '@/constants/gameicons';

import LogoImage from '@/assets/img/home/banner/habby@2x.png';

const BannerView = () => {
    const availableList = GAME_ICON_LIST.filter(i => i.isShow);
    return (
        <SectionContainer
            className="home-banner-view"
            imageRender={() => {
                return (
                    <picture>
                        <source
                            srcSet={require('@/assets/img/home/banner/home_page_banner@768.png')}
                            media="(max-width: 768px)"
                        />
                        <img
                            className="background-image"
                            src={require('@/assets/img/home/banner/background.png')}
                            alt=""
                        />
                    </picture>
                );
            }}
        >
            <div className="content">
                <div className="logo-wrapper">
                    <img src={LogoImage} alt="" />
                </div>
                <p className="desc">{formatMessage('game.content.declare')}</p>
                <div className="game-icon-view">
                    {availableList.map(i => (
                    <div className="game-icon-wrap">
                        <GameCard
                            title={formatMessage(i.title)}
                            icon={i.pcIcon}
                            id={i.id}
                        />
                    </div>
                    ))}
                </div>
            </div>
        </SectionContainer>
    );
};

export default BannerView;
